import { Controller } from "@hotwired/stimulus"
import { useDispatch } from "stimulus-use"

export default class extends Controller {
  connect() {
    useDispatch(this)
    this.element[`${this.identifier}-controller`.replace(/\-/g, "_")] = this
  }
}
